/* global angular, _ */
module.exports = ['$scope', 'curriculumManager', 'bibContentManager', '$location', 'odetManager', '$stateParams', '$state', 'ngMeta',
  function ($scope, CurriculumManager, bibContentManager, $location, odetManager, $stateParams, $state, ngMeta) {
    'use strict';
    $scope.$parent.hideSearchBar = false;

    $scope.$parent.selected = {};
    $scope.$parent.options = {};
    $scope.results = [];
    $scope.searched = {};
    $scope.$parent.loaded = false;

    function removeDuplicateElementsByKey(arr) {
      return Object.values(arr.reduce((acc, cur)=>Object.assign(acc, {[cur.key]: cur}), {}));
    }

    $scope.$parent.search = function () {
      if ($scope.$parent.selected.way && $scope.$parent.selected.way.key === 0) {

        if ($scope.$parent.selected.goal && $scope.$parent.selected.goal.type === 'goal') {
          $scope.searched.type = 'goal';
          $scope.searched.count = 0;
          $scope.searched.selected = angular.copy($scope.$parent.selected);
          CurriculumManager.getFieldByHref('/content/' + $scope.$parent.selected.field.key).then(function (field) {
            $scope.searched.field = field;
          });
          CurriculumManager.getThemeByHref('/content/' + $scope.$parent.selected.theme.key).then(function (theme) {
            $scope.searched.theme = theme;
          });
          CurriculumManager.getGoalByHref('/content/' + $scope.$parent.selected.goal.key).then(function (goal) {
            $scope.searched.goal = goal;
            ngMeta.setTitle(goal.code + '- concordanties');
          });

          $scope.results = [];
          CurriculumManager.getGoalByHref('/content/' + $scope.$parent.selected.goal.key).then(function (goal) {
            $scope.searched.goal = goal;

            odetManager.getConcordantieByZillGoal($scope.$parent.selected.type.key, $scope.$parent.selected.goal.key)
              .then(function (results) {
                $scope.results.goal = results;
                $scope.searched.count = $scope.searched.count + results.length;
              });

            /* To also show contents
            odetManager.getConcordantieByZill($scope.$parent.selected.type.key, $scope.$parent.selected.goal.key)
              .then(function (results) {
                $scope.results.goal = results;
                $scope.searched.count = $scope.searched.count + results.length;
              });

            CurriculumManager.getGoalByHref('/content/' + $scope.$parent.selected.goal.key).then(function (goal) {
              $scope.searched.goal = goal;
              if (goal.contentGroups) {
                goal.contentGroups.forEach(function (contentGroup) {
                  if (contentGroup.content1s) {
                    contentGroup.content1s.forEach(function (content1) {
                      odetManager.getConcordantieByZill($scope.$parent.selected.type.key, content1.key)
                        .then(function (results) {
                          console.log(content1.key);
                          console.log(results);
                          $scope.results[content1.key] = results;
                          $scope.searched.count = $scope.searched.count + results.length;
                        });
                      if (content1.content2s) {
                        content1.content2s.forEach(function (content2) {
                          odetManager.getConcordantieByZill($scope.$parent.selected.type.key, content2.key)
                            .then(function (results) {
                              $scope.results[content2.key] = results;
                              $scope.searched.count = $scope.searched.count + results.length;
                            });
                        });
                      }
                    });
                  }
                });
              }
            });
            */
          });

        } else if ($scope.$parent.selected.theme && $scope.$parent.selected.theme.type === 'theme') {

          $scope.searched.type = 'theme';
          $scope.searched.selected = angular.copy($scope.$parent.selected);
          $scope.searched.results = [];
          $scope.searched.count = 0;
          CurriculumManager.getFieldByHref('/content/' + $scope.$parent.selected.field.key).then(function (field) {
            $scope.searched.field = field;
          });
          CurriculumManager.getThemeByHref('/content/' + $scope.$parent.selected.theme.key).then(function (theme) {
            $scope.searched.theme = theme;
            ngMeta.setTitle(theme.title + ' - concordanties');
          });
          $scope.$parent.selected.theme.goals.forEach(function (value) {
            odetManager.getConcordantieByZillGoal($scope.$parent.selected.type.key, value.key)
              .then(function (results) {
                $scope.searched.results[value.key] = results;
                $scope.searched.count = $scope.searched.count + results.length;
              });
          });

        } else if ($scope.$parent.selected.field && $scope.$parent.selected.field.type === 'field') {
          $scope.searched.type = 'field';
          $scope.searched.selected = angular.copy($scope.$parent.selected);
          $scope.searched.results = [];
          $scope.searched.count = 0;
          CurriculumManager.getFieldByHref('/content/' + $scope.$parent.selected.field.key).then(function (field) {
            $scope.searched.field = field;
            ngMeta.setTitle(field.title + ' - concordanties');
          });
          $scope.$parent.selected.field.themes.forEach(function (value) {
            if (value.goals) {
              value.goals.forEach(function (value2) {
                if (value2.type === 'goal') {
                  odetManager.getConcordantieByZillGoal($scope.$parent.selected.type.key, value2.key)
                    .then(function (results) {
                      $scope.searched.results[value2.key] = results;
                      $scope.searched.count = $scope.searched.count + results.length;
                    });
                }
              });
            }
          });
        }
      }else if ($scope.$parent.selected.way && $scope.$parent.selected.way.key === 1) {
        if ($scope.$parent.selected.odetGoal && $scope.$parent.selected.odetGoal.type === 'goal') {
          $scope.searched.type = 'odet';
          $scope.searched.selected = angular.copy($scope.$parent.selected);
          $scope.searched.results = [];
          $scope.searched.count = 0;
          ngMeta.setTitle($scope.$parent.selected.odetGoal.code + ' - concordanties');
          odetManager.getConcordantieByOdet($scope.$parent.selected.type.key, $scope.$parent.selected.odetGoal.key)
            .then((results) => {
              results = removeDuplicateElementsByKey(results);
              $scope.searched.count = results.length;
              var k, goal;
              for (k in results) {
                if (results[k]) {
                  goal = results[k];
                  if (goal.theme && goal.theme.field) {
                    if (!$scope.searched.results[goal.theme.field.key]) {
                      $scope.searched.results[goal.theme.field.key] = [];
                    }
                    $scope.searched.results[goal.theme.field.key].push(goal);
                  } else if (goal.contentGroup && goal.contentGroup.goal.theme.field) {
                    if (!$scope.searched.results[goal.contentGroup.goal.theme.field.key]) {
                      $scope.searched.results[goal.contentGroup.goal.theme.field.key] = [];
                    }
                    $scope.searched.results[goal.contentGroup.goal.theme.field.key].push(goal);
                  } else if (goal.content1 && goal.content1.contentGroup.goal.theme.field) {
                    if (!$scope.searched.results[goal.content1.contentGroup.goal.theme.field.key]) {
                      $scope.searched.results[goal.content1.contentGroup.goal.theme.field.key] = [];
                    }
                    $scope.searched.results[goal.content1.contentGroup.goal.theme.field.key].push(goal);
                  }
                }
              }
              $scope.searched.count = results.length;
              $scope.next = odetManager.getNext($scope.$parent.selected.odetGoal.key);
            });
        }
      }
    };

    $scope.goUp = function (keyName) {
      var params = {};
      params[keyName] = 0;
      $state.go('bib.search.concordanties', params);
    };

    $scope.goPrev = function (object, keyName) {
      if(keyName === 'odetGoal') {
        odetManager.getPrev(object).then(function (prev) {
          var params = {};
          params[keyName] = prev.key;
          $state.go('bib.search.concordanties', params);
        });
      } else {
        CurriculumManager.getPrev(object).then(function (prev) {
          var params = {};
          params[keyName] = prev.key;
          $state.go('bib.search.concordanties', params);
        });
      }
    };

    $scope.goNext = function (object, keyName) {
      if(keyName === 'odetGoal') {
        odetManager.getNext(object).then(function (next) {
          var params = {};
          params[keyName] = next.key;
          $state.go('bib.search.concordanties', params);
        });
      } else {
        CurriculumManager.getNext(object).then(function (next) {
          var params = {};
          params[keyName] = next.key;
          $state.go('bib.search.concordanties', params);
        });
      }
    };

    var options = {
      field: [],
      theme: [
        {
          key: '0',
          type: 'static',
          icon: '',
          color: '',
          title: 'geen thema'
        }
      ],
      goal: [
        {
          key: '0',
          type: 'static',
          icon: '',
          color: '',
          title: 'geen doel'
        }
      ],
      leergebied: [],
      domain: [],
      odetGoal: [],
      type: [],
      way: [
        {
          key: 0,
          title: 'van ZILL naar OD/ET'
        },
        {
          key: 1,
          title: 'van OD/ET naar ZILL'
        }
      ]
    };

    //Set options for selection
    var loadOptions = function (fields, odet) {
      //Adding fields, themes, goals
      fields.forEach(function (value) {
        options.field.push({
          type: 'field',
          key: value.key,
          title: value.title,
          color: value.color,
          iconUrl: value.iconUrl,
          themes: value.themes.map(function (theme) {
            return {
              type: 'theme',
              key: theme.key,
              title: theme.title,
              goals: theme.goals.map(function (goal) {
                return {
                  type: 'goal',
                  key: goal.key,
                  title: goal.title,
                  code: goal.code
                };
              })
            };
          })
        });
      });

      options.field.forEach(function (field) {
        field.themes = _.concat(options.theme, field.themes);
        field.themes.forEach(function (theme) {
          if (theme.type === 'theme') {
            theme.goals = _.concat(options.goal, theme.goals);
          }
        });
      });

      function addOdetGoals(subsection, toAdd) {
        if (subsection.subsections) {
          subsection.subsections.forEach(function (value) {
            addOdetGoals(value, toAdd);
          });
          addOdetGoals(subsection.subsections, toAdd);
        } else if (subsection.goals) {
          subsection.goals.forEach(function (value) {
            toAdd.push({
              type: 'goal',
              key: value.key,
              title: value.title,
              description: value.description ? value.description : null,
              code: value.code
            });
          });
        }
      }

      odet.levels.forEach(function (level, key) {
        options.type.push({
          key: level.key,
          title: level.title
        });

        if (!options.leergebied[level.key]) {
          options.leergebied[level.key] = [];
        }
        var leergebiedItem = {};
        level.leergebieden.forEach(function (leergebied) {
          leergebiedItem = {
            type: 'leergebied',
            key: leergebied.key,
            title: leergebied.title,
            domains: []
          };
          if (leergebied.subsections) {
            var domainItem = {};
            leergebied.subsections.forEach(function (domain) {
              domainItem = {
                type: 'domain',
                key: domain.key,
                title: domain.title,
                goals: []
              };
              addOdetGoals(domain, domainItem.goals);
              leergebiedItem.domains.push(domainItem);
            });
          }
          if (leergebied.goals) {
            leergebiedItem.goals = leergebied.goals.map(function (goal) {
              return {
                type: 'goal',
                key: goal.key,
                title: goal.title,
                code: goal.code
              };
            });
          }
          options.leergebied[level.key].push(leergebiedItem);
        });
      });


      $scope.$parent.options = options;

      // Form fields are populated with the values from the URL, if any.
      // search parameters > first value in the list of options.
      // concordanties doesn't inherit previously chosen values in BIB.
      if ($stateParams.way && _.findIndex($scope.$parent.options.way, function (o) { return o.key === parseInt($stateParams.way, 0); }) > -1) {
        $scope.$parent.selected.way = _.find($scope.$parent.options.way, function (o) { return o.key === parseInt($stateParams.way, 0); });
      } else {
        $scope.$parent.selected.way = $scope.$parent.options.way[0]; //set first as selected
      }

      if ($stateParams.type && _.findIndex($scope.$parent.options.type, function (o) { return o.key === $stateParams.type; }) > -1) {
        $scope.$parent.selected.type = _.find($scope.$parent.options.type, function (o) { return o.key === $stateParams.type; });
      } else {
        $scope.$parent.selected.type = $scope.$parent.options.type[1]; //set first as selected
      }

      if ($stateParams.field && _.findIndex($scope.$parent.options.field, function (o) { return o.key === $stateParams.field; }) > -1) {
        $scope.$parent.selected.field = _.find($scope.$parent.options.field, function (o) { return o.key === $stateParams.field; });
      } else {
        $scope.$parent.selected.field = $scope.$parent.options.field[0]; //set first as selected
      }

      if ($stateParams.theme && _.findIndex($scope.$parent.selected.field.themes, function (o) { return o.key === $stateParams.theme; }) > -1) {
        $scope.$parent.selected.theme = _.find($scope.$parent.selected.field.themes, function (o) { return o.key === $stateParams.theme; });
      } else {
        $scope.$parent.selected.theme = $scope.$parent.selected.field.themes[0]; //set first as selected
      }

      if ($scope.$parent.selected.theme.goals) {
        if ($stateParams.goal && _.findIndex($scope.$parent.selected.theme.goals, function (o) { return o.key === $stateParams.goal; }) > -1) {
          $scope.$parent.selected.goal = _.find($scope.$parent.selected.theme.goals, function (o) { return o.key === $stateParams.goal; });
        } else {
          $scope.$parent.selected.goal = $scope.$parent.selected.theme.goals[0]; //set first as selected
        }
      }

      if ($stateParams.leergebied && _.findIndex($scope.$parent.options.leergebied[$scope.$parent.selected.type.key], function (o) { return o.key === $stateParams.leergebied; })) {
        $scope.$parent.selected.leergebied = _.find($scope.$parent.options.leergebied[$scope.$parent.selected.type.key], function (o) { return o.key === $stateParams.leergebied; });
      } else {
        $scope.$parent.selected.leergebied = $scope.$parent.options.leergebied[$scope.$parent.selected.type.key][0]; //set first as selected
      }

      if ($scope.$parent.selected.leergebied.domains.length > 0) {
        if ($stateParams.domain && _.findIndex($scope.$parent.selected.leergebied.domains, function (o) { return o.key === $stateParams.domain; }) > -1) {
          $scope.$parent.selected.domain = _.find($scope.$parent.selected.leergebied.domains, function (o) { return o.key === $stateParams.domain; });
        } else {
          $scope.$parent.selected.domain = $scope.$parent.selected.leergebied.domains[0]; //set first as selected
        }

        if ($stateParams.odetGoal && _.findIndex($scope.$parent.selected.domain.goals, function (o) { return o.key === $stateParams.odetGoal; }) > -1) {
          $scope.$parent.selected.odetGoal = _.find($scope.$parent.selected.domain.goals, function (o) { return o.key === $stateParams.odetGoal; });
        } else {
          $scope.$parent.selected.odetGoal = $scope.$parent.selected.domain.goals[0]; //set first as selected
        }
      } else if ($scope.$parent.selected.leergebied.goals) {
        if ($stateParams.odetGoal && _.findIndex($scope.$parent.selected.leergebied.goals, function (o) { return o.key === $stateParams.odetGoal; }) > -1) {
          $scope.$parent.selected.odetGoal = _.find($scope.$parent.selected.leergebied.goals, function (o) { return o.key === $stateParams.odetGoal; });
          console.log($scope.$parent.selected.odetGoal);
        } else {
          $scope.$parent.selected.odetGoal = $scope.$parent.selected.leergebied.goals[0]; //set first as selected
        }
      }
    };

    CurriculumManager.getFields().then(function (fields) {
      odetManager.getCurriculum().then(function (odet) {
        loadOptions(fields, odet);
        $scope.$parent.loaded = true;
        $scope.$parent.search();
      });
    });

    $scope.$parent.changeLeergebied = function (leergebied) {
      console.log('leergebied change');
      if ($scope.$parent.loaded) {
        if (leergebied.domains.length > 0) {
          $scope.$parent.selected.domain = leergebied.domains[0]; //set first as selected
        } else {
          $scope.$parent.selected.domain = {};
          $scope.$parent.selected.odetGoal = leergebied.goals[0]; //set first as selected
        }
      }
    };

    $scope.$parent.changeDomain = function (domain) {
      if ($scope.$parent.loaded) {
        $scope.$parent.selected.odetGoal = domain.goals[0]; //set first as selected
      }
    };

  }
];



// WEBPACK FOOTER //
// ./web/js/screen/bib/search/concordanties/bibSearchConcordantiesController.js